import { Http, BaseRequestOptions, Response, ResponseOptions, RequestMethod, XHRBackend, RequestOptions } from '@angular/http';
import { MockBackend } from '@angular/http/testing';
import { topCourses, viewProfile, networkUpdates, degreeCourse, pastEducation, editAboutMe, myInterest } from '../helpers';
export var fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: Http,
    useFactory: function (backend, options, realBackend) {
        // array in local storage for registered users
        var users = JSON.parse(localStorage.getItem('users')) || [];
        // configure fake backend
        backend.connections.subscribe(function (connection) {
            // wrap in timeout to simulate server api call
            setTimeout(function () {
                // user authenticate
                if (connection.request.url.endsWith('/homepage/topCourses') && connection.request.method === RequestMethod.Get) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: topCourses
                    })));
                    return;
                }
                // user authenticate
                if (connection.request.url.endsWith('/homepage/networkUpdates') && connection.request.method === RequestMethod.Get) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: networkUpdates
                    })));
                    return;
                }
                // user authenticate
                if (connection.request.url.endsWith('/view/profile') && connection.request.method === RequestMethod.Get) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: viewProfile
                    })));
                    return;
                }
                // user authenticate
                if (connection.request.url.endsWith('/edit/profile/degreeCourse') && connection.request.method === RequestMethod.Post) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: degreeCourse
                    })));
                    return;
                }
                // user authenticate
                if (connection.request.url.endsWith('/edit/profile/add/pasteducation') && connection.request.method === RequestMethod.Post) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: pastEducation
                    })));
                    return;
                }
                if (connection.request.url.endsWith('/edit/profile/aboutMe') && connection.request.method === RequestMethod.Post) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: editAboutMe
                    })));
                    return;
                }
                if (connection.request.url.endsWith('/edit/profile/myInterests') && connection.request.method === RequestMethod.Post) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: myInterest
                    })));
                    return;
                }
                // user authenticate
                if (connection.request.url.endsWith('/edit/profile/educationalQualification') && connection.request.method === RequestMethod.Post) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: {
                            "startIndex": 0,
                            "noOfRowsToFetch": 0,
                            "mapOfAdditinalParams": null,
                            "createdBy": null,
                            "createdOn": 1478284428000,
                            "lastUpdatedBy": "ANONYMOUS",
                            "lastUpdatedOn": 1478284525000,
                            "expiryOn": null,
                            "createdOnDateForDisplay": "11/04/2016",
                            "createdOnDateInDDMmYYYFormat": null,
                            "formattedCreatedDateForDisplay": null,
                            "formattedUpdatedDateForDisplay": null,
                            "invitationAction": null,
                            "ratingAction": null,
                            "userDetailsId": 42,
                            "firstName": "Fast",
                            "middleName": null,
                            "lastName": "SSD",
                            "emailId": "fastssd27@uvsity.com",
                            "gender": "M",
                            "phoneMobile": null,
                            "phoneWork": null,
                            "phoneHome": null,
                            "userType": "Professor Emeritus",
                            "userBaseType": "Professor",
                            "isEduInsUserDefined": true,
                            "educationalInstitution": "Alabama Scientific Research Institute",
                            "campus": "Alabama South City",
                            "userEducationDegreeCourse": "Master",
                            "userEducationYear": null,
                            "userEducationSemester": null,
                            "userEducationCourseStatus": null,
                            "userEducationSubject": "Semiconductors and Embedded Systems",
                            "userEducationSpecialization": null,
                            "aboutMe": null,
                            "myInterests": null,
                            "professorConnectionCount": null,
                            "studentConnectionCount": null,
                            "alumniConnectionCount": null,
                            "noOfRatingStars": null,
                            "profilePicName": null,
                            "privacySettingsTO": {
                                "startIndex": 0,
                                "noOfRowsToFetch": 0,
                                "mapOfAdditinalParams": null,
                                "createdBy": "ANONYMOUS",
                                "createdOn": 1478284524000,
                                "lastUpdatedBy": null,
                                "lastUpdatedOn": null,
                                "expiryOn": null,
                                "createdOnDateForDisplay": "11/04/2016",
                                "createdOnDateInDDMmYYYFormat": null,
                                "formattedCreatedDateForDisplay": null,
                                "formattedUpdatedDateForDisplay": null,
                                "privacySettingsId": 20,
                                "profileVisibility": "EVERYONE",
                                "showProfileVisitors": "ENABLED",
                                "emailNotifications": "ENABLED"
                            },
                            "webTO": {
                                "userDetailsId": 42,
                                "firstName": "Fast",
                                "middleName": null,
                                "lastName": "SSD",
                                "emailId": "fastssd27@uvsity.com",
                                "gender": "M",
                                "phoneMobile": null,
                                "phoneWork": null,
                                "phoneHome": null,
                                "userType": "Professor Emeritus",
                                "userBaseType": "Professor",
                                "isEduInsUserDefined": true,
                                "educationalInstitution": "Alabama Scientific Research Institute",
                                "campus": "Alabama South City",
                                "userEducationDegreeCourse": "Master",
                                "userEducationYear": null,
                                "userEducationSemester": null,
                                "userEducationCourseStatus": null,
                                "userEducationSubject": "Semiconductors and Embedded Systems",
                                "userEducationSpecialization": null,
                                "professorConnectionCount": null,
                                "studentConnectionCount": null,
                                "alumniConnectionCount": null,
                                "noOfRatingStars": null,
                                "profilePicName": null
                            }
                        }
                    })));
                    return;
                }
                // user summary
                if (connection.request.url.endsWith('/homepage/userSummary') && connection.request.method === RequestMethod.Get) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: {
                            "userDetailsId": 42,
                            "firstName": "Fast",
                            "middleName": null,
                            "lastName": "SSD",
                            "emailId": "fastssd27@uvsity.com",
                            "gender": "M",
                            "phoneMobile": null,
                            "phoneWork": null,
                            "phoneHome": null,
                            "userType": "Senior lecturer",
                            "userBaseType": "Professor",
                            "isEduInsUserDefined": true,
                            "educationalInstitution": "Alabama State University",
                            "campus": "Alabama",
                            "userEducationDegreeCourse": "Master",
                            "userEducationYear": null,
                            "userEducationSemester": null,
                            "userEducationCourseStatus": null,
                            "userEducationSubject": "Computer Science",
                            "userEducationSpecialization": null,
                            "professorConnectionCount": null,
                            "studentConnectionCount": null,
                            "alumniConnectionCount": null,
                            "noOfRatingStars": null,
                            "profilePicName": null,
                            "token": 'fake-jwt-token'
                        }
                    })));
                    return;
                }
                // profileVisits
                if (connection.request.url.endsWith('/homepage/profileVisits') && connection.request.method === RequestMethod.Get) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: [
                            {
                                "startIndex": 0,
                                "noOfRowsToFetch": 0,
                                "mapOfAdditinalParams": null,
                                "createdBy": "ANONYMOUS",
                                "createdOn": 1469281000000,
                                "lastUpdatedBy": null,
                                "lastUpdatedOn": null,
                                "expiryOn": null,
                                "createdOnDateForDisplay": "07/23/2016",
                                "createdOnDateInDDMmYYYFormat": null,
                                "formattedCreatedDateForDisplay": null,
                                "formattedUpdatedDateForDisplay": null,
                                "profileVisitId": 10,
                                "visitedUserId": 13,
                                "visitorUserId": 17,
                                "visitorUserSummary": {
                                    "startIndex": 0,
                                    "noOfRowsToFetch": 0,
                                    "mapOfAdditinalParams": null,
                                    "createdBy": null,
                                    "createdOn": 1469278576000,
                                    "lastUpdatedBy": "ANONYMOUS",
                                    "lastUpdatedOn": 1469280994000,
                                    "expiryOn": null,
                                    "createdOnDateForDisplay": "07/23/2016",
                                    "createdOnDateInDDMmYYYFormat": null,
                                    "formattedCreatedDateForDisplay": null,
                                    "formattedUpdatedDateForDisplay": null,
                                    "invitationAction": null,
                                    "ratingAction": null,
                                    "userDetailsId": 17,
                                    "firstName": "Test Three",
                                    "middleName": null,
                                    "lastName": "User",
                                    "emailId": "gtest3@uvsity.com",
                                    "gender": "M",
                                    "phoneMobile": null,
                                    "phoneWork": null,
                                    "phoneHome": null,
                                    "userType": "Student",
                                    "userBaseType": "Student",
                                    "isEduInsUserDefined": true,
                                    "educationalInstitution": "Alabama State College of Barber Styling",
                                    "campus": "Alabama",
                                    "userEducationDegreeCourse": "Master",
                                    "userEducationYear": null,
                                    "userEducationSemester": null,
                                    "userEducationCourseStatus": null,
                                    "userEducationSubject": "Computer Science",
                                    "userEducationSpecialization": "Computer Science",
                                    "aboutMe": null,
                                    "myInterests": null,
                                    "professorConnectionCount": 1,
                                    "studentConnectionCount": null,
                                    "alumniConnectionCount": null,
                                    "noOfRatingStars": null,
                                    "profilePicName": "https://s3.amazonaws.com/uvsityImages/profilebig.png",
                                    "privacySettingsTO": {
                                        "startIndex": 0,
                                        "noOfRowsToFetch": 0,
                                        "mapOfAdditinalParams": null,
                                        "createdBy": "ANONYMOUS",
                                        "createdOn": 1469278616000,
                                        "lastUpdatedBy": null,
                                        "lastUpdatedOn": null,
                                        "expiryOn": null,
                                        "createdOnDateForDisplay": "07/23/2016",
                                        "createdOnDateInDDMmYYYFormat": null,
                                        "formattedCreatedDateForDisplay": null,
                                        "formattedUpdatedDateForDisplay": null,
                                        "privacySettingsId": 17,
                                        "profileVisibility": "EVERYONE",
                                        "showProfileVisitors": "ENABLED",
                                        "emailNotifications": "ENABLED"
                                    },
                                    "webTO": {
                                        "userDetailsId": 17,
                                        "firstName": "Test Three",
                                        "middleName": null,
                                        "lastName": "User",
                                        "emailId": "gtest3@uvsity.com",
                                        "gender": "M",
                                        "phoneMobile": null,
                                        "phoneWork": null,
                                        "phoneHome": null,
                                        "userType": "Student",
                                        "userBaseType": "Student",
                                        "isEduInsUserDefined": true,
                                        "educationalInstitution": "Alabama State College of Barber Styling",
                                        "campus": "Alabama",
                                        "userEducationDegreeCourse": "Master",
                                        "userEducationYear": null,
                                        "userEducationSemester": null,
                                        "userEducationCourseStatus": null,
                                        "userEducationSubject": "Computer Science",
                                        "userEducationSpecialization": "Computer Science",
                                        "professorConnectionCount": 1,
                                        "studentConnectionCount": null,
                                        "alumniConnectionCount": null,
                                        "noOfRatingStars": null,
                                        "profilePicName": "https://s3.amazonaws.com/uvsityImages/profilebig.png"
                                    }
                                }
                            },
                            {
                                "startIndex": 0,
                                "noOfRowsToFetch": 0,
                                "mapOfAdditinalParams": null,
                                "createdBy": "ANONYMOUS",
                                "createdOn": 1475961127000,
                                "lastUpdatedBy": null,
                                "lastUpdatedOn": null,
                                "expiryOn": null,
                                "createdOnDateForDisplay": "10/08/2016",
                                "createdOnDateInDDMmYYYFormat": null,
                                "formattedCreatedDateForDisplay": null,
                                "formattedUpdatedDateForDisplay": null,
                                "profileVisitId": 14,
                                "visitedUserId": 13,
                                "visitorUserId": 22,
                                "visitorUserSummary": {
                                    "startIndex": 0,
                                    "noOfRowsToFetch": 0,
                                    "mapOfAdditinalParams": null,
                                    "createdBy": null,
                                    "createdOn": 1475939879000,
                                    "lastUpdatedBy": "ANONYMOUS",
                                    "lastUpdatedOn": 1475960857000,
                                    "expiryOn": null,
                                    "createdOnDateForDisplay": "10/08/2016",
                                    "createdOnDateInDDMmYYYFormat": null,
                                    "formattedCreatedDateForDisplay": null,
                                    "formattedUpdatedDateForDisplay": null,
                                    "invitationAction": null,
                                    "ratingAction": null,
                                    "userDetailsId": 22,
                                    "firstName": "Sandipan",
                                    "middleName": null,
                                    "lastName": "De",
                                    "emailId": "sandipan1.de@gmail.com",
                                    "gender": "M",
                                    "phoneMobile": null,
                                    "phoneWork": null,
                                    "phoneHome": null,
                                    "userType": "Alumni",
                                    "userBaseType": "Alumni",
                                    "isEduInsUserDefined": true,
                                    "educationalInstitution": "Amridge University",
                                    "campus": "Arizona City",
                                    "userEducationDegreeCourse": "Master",
                                    "userEducationYear": null,
                                    "userEducationSemester": null,
                                    "userEducationCourseStatus": null,
                                    "userEducationSubject": "Electronics",
                                    "userEducationSpecialization": "Electronics",
                                    "aboutMe": null,
                                    "myInterests": null,
                                    "professorConnectionCount": null,
                                    "studentConnectionCount": null,
                                    "alumniConnectionCount": null,
                                    "noOfRatingStars": null,
                                    "profilePicName": "https://s3.amazonaws.com/uvsityImages/profilebig.png",
                                    "privacySettingsTO": {
                                        "startIndex": 0,
                                        "noOfRowsToFetch": 0,
                                        "mapOfAdditinalParams": null,
                                        "createdBy": "ANONYMOUS",
                                        "createdOn": 1475925574000,
                                        "lastUpdatedBy": null,
                                        "lastUpdatedOn": null,
                                        "expiryOn": null,
                                        "createdOnDateForDisplay": "10/08/2016",
                                        "createdOnDateInDDMmYYYFormat": null,
                                        "formattedCreatedDateForDisplay": null,
                                        "formattedUpdatedDateForDisplay": null,
                                        "privacySettingsId": 22,
                                        "profileVisibility": "EVERYONE",
                                        "showProfileVisitors": "ENABLED",
                                        "emailNotifications": "ENABLED"
                                    },
                                    "webTO": {
                                        "userDetailsId": 22,
                                        "firstName": "Sandipan",
                                        "middleName": null,
                                        "lastName": "De",
                                        "emailId": "sandipan1.de@gmail.com",
                                        "gender": "M",
                                        "phoneMobile": null,
                                        "phoneWork": null,
                                        "phoneHome": null,
                                        "userType": "Alumni",
                                        "userBaseType": "Alumni",
                                        "isEduInsUserDefined": true,
                                        "educationalInstitution": "Amridge University",
                                        "campus": "Arizona City",
                                        "userEducationDegreeCourse": "Master",
                                        "userEducationYear": null,
                                        "userEducationSemester": null,
                                        "userEducationCourseStatus": null,
                                        "userEducationSubject": "Electronics",
                                        "userEducationSpecialization": "Electronics",
                                        "professorConnectionCount": null,
                                        "studentConnectionCount": null,
                                        "alumniConnectionCount": null,
                                        "noOfRatingStars": null,
                                        "profilePicName": "https://s3.amazonaws.com/uvsityImages/profilebig.png"
                                    }
                                }
                            },
                            {
                                "startIndex": 0,
                                "noOfRowsToFetch": 0,
                                "mapOfAdditinalParams": null,
                                "createdBy": "ANONYMOUS",
                                "createdOn": 1477567238000,
                                "lastUpdatedBy": null,
                                "lastUpdatedOn": null,
                                "expiryOn": null,
                                "createdOnDateForDisplay": "10/27/2016",
                                "createdOnDateInDDMmYYYFormat": null,
                                "formattedCreatedDateForDisplay": null,
                                "formattedUpdatedDateForDisplay": null,
                                "profileVisitId": 15,
                                "visitedUserId": 13,
                                "visitorUserId": 23,
                                "visitorUserSummary": {
                                    "startIndex": 0,
                                    "noOfRowsToFetch": 0,
                                    "mapOfAdditinalParams": null,
                                    "createdBy": null,
                                    "createdOn": 1477610184000,
                                    "lastUpdatedBy": "ANONYMOUS",
                                    "lastUpdatedOn": 1477567286000,
                                    "expiryOn": null,
                                    "createdOnDateForDisplay": "10/27/2016",
                                    "createdOnDateInDDMmYYYFormat": null,
                                    "formattedCreatedDateForDisplay": null,
                                    "formattedUpdatedDateForDisplay": null,
                                    "invitationAction": null,
                                    "ratingAction": null,
                                    "userDetailsId": 23,
                                    "firstName": "Minesh",
                                    "middleName": null,
                                    "lastName": "B",
                                    "emailId": "mineshbhadeshia@gmail.com",
                                    "gender": "M",
                                    "phoneMobile": null,
                                    "phoneWork": null,
                                    "phoneHome": null,
                                    "userType": "Alumni",
                                    "userBaseType": "Alumni",
                                    "isEduInsUserDefined": true,
                                    "educationalInstitution": "Enterprise State Community College",
                                    "campus": "Arizona City",
                                    "userEducationDegreeCourse": "Master",
                                    "userEducationYear": null,
                                    "userEducationSemester": null,
                                    "userEducationCourseStatus": null,
                                    "userEducationSubject": "Computer Science",
                                    "userEducationSpecialization": "Computer Science",
                                    "aboutMe": null,
                                    "myInterests": null,
                                    "professorConnectionCount": 1,
                                    "studentConnectionCount": null,
                                    "alumniConnectionCount": null,
                                    "noOfRatingStars": null,
                                    "profilePicName": "https://s3.amazonaws.com/uvsityImages/profilebig.png",
                                    "privacySettingsTO": {
                                        "startIndex": 0,
                                        "noOfRowsToFetch": 0,
                                        "mapOfAdditinalParams": null,
                                        "createdBy": "ANONYMOUS",
                                        "createdOn": 1477567062000,
                                        "lastUpdatedBy": null,
                                        "lastUpdatedOn": null,
                                        "expiryOn": null,
                                        "createdOnDateForDisplay": "10/27/2016",
                                        "createdOnDateInDDMmYYYFormat": null,
                                        "formattedCreatedDateForDisplay": null,
                                        "formattedUpdatedDateForDisplay": null,
                                        "privacySettingsId": 23,
                                        "profileVisibility": "EVERYONE",
                                        "showProfileVisitors": "ENABLED",
                                        "emailNotifications": "ENABLED"
                                    },
                                    "webTO": {
                                        "userDetailsId": 23,
                                        "firstName": "Minesh",
                                        "middleName": null,
                                        "lastName": "B",
                                        "emailId": "mineshbhadeshia@gmail.com",
                                        "gender": "M",
                                        "phoneMobile": null,
                                        "phoneWork": null,
                                        "phoneHome": null,
                                        "userType": "Alumni",
                                        "userBaseType": "Alumni",
                                        "isEduInsUserDefined": true,
                                        "educationalInstitution": "Enterprise State Community College",
                                        "campus": "Arizona City",
                                        "userEducationDegreeCourse": "Master",
                                        "userEducationYear": null,
                                        "userEducationSemester": null,
                                        "userEducationCourseStatus": null,
                                        "userEducationSubject": "Computer Science",
                                        "userEducationSpecialization": "Computer Science",
                                        "professorConnectionCount": 1,
                                        "studentConnectionCount": null,
                                        "alumniConnectionCount": null,
                                        "noOfRatingStars": null,
                                        "profilePicName": "https://s3.amazonaws.com/uvsityImages/profilebig.png"
                                    }
                                }
                            },
                            {
                                "startIndex": 0,
                                "noOfRowsToFetch": 0,
                                "mapOfAdditinalParams": null,
                                "createdBy": "ANONYMOUS",
                                "createdOn": 1477567343000,
                                "lastUpdatedBy": null,
                                "lastUpdatedOn": null,
                                "expiryOn": null,
                                "createdOnDateForDisplay": "10/27/2016",
                                "createdOnDateInDDMmYYYFormat": null,
                                "formattedCreatedDateForDisplay": null,
                                "formattedUpdatedDateForDisplay": null,
                                "profileVisitId": 16,
                                "visitedUserId": 13,
                                "visitorUserId": 14,
                                "visitorUserSummary": {
                                    "startIndex": 0,
                                    "noOfRowsToFetch": 0,
                                    "mapOfAdditinalParams": null,
                                    "createdBy": null,
                                    "createdOn": 1469293889000,
                                    "lastUpdatedBy": "ANONYMOUS",
                                    "lastUpdatedOn": 1484307017000,
                                    "expiryOn": null,
                                    "createdOnDateForDisplay": "07/23/2016",
                                    "createdOnDateInDDMmYYYFormat": null,
                                    "formattedCreatedDateForDisplay": null,
                                    "formattedUpdatedDateForDisplay": null,
                                    "invitationAction": null,
                                    "ratingAction": null,
                                    "userDetailsId": 14,
                                    "firstName": "Stacy",
                                    "middleName": null,
                                    "lastName": "Richard",
                                    "emailId": "stacy@uvsity.com",
                                    "gender": "F",
                                    "phoneMobile": null,
                                    "phoneWork": null,
                                    "phoneHome": null,
                                    "userType": "Student",
                                    "userBaseType": "Student",
                                    "isEduInsUserDefined": true,
                                    "educationalInstitution": "Amridge University",
                                    "campus": "Tennesse",
                                    "userEducationDegreeCourse": "Master",
                                    "userEducationYear": null,
                                    "userEducationSemester": null,
                                    "userEducationCourseStatus": null,
                                    "userEducationSubject": "Medical Science",
                                    "userEducationSpecialization": "Medical Science",
                                    "aboutMe": null,
                                    "myInterests": null,
                                    "professorConnectionCount": 1,
                                    "studentConnectionCount": null,
                                    "alumniConnectionCount": null,
                                    "noOfRatingStars": null,
                                    "profilePicName": "https://s3.amazonaws.com/uvsityImages/14",
                                    "privacySettingsTO": {
                                        "startIndex": 0,
                                        "noOfRowsToFetch": 0,
                                        "mapOfAdditinalParams": null,
                                        "createdBy": "ANONYMOUS",
                                        "createdOn": 1469265375000,
                                        "lastUpdatedBy": null,
                                        "lastUpdatedOn": null,
                                        "expiryOn": null,
                                        "createdOnDateForDisplay": "07/23/2016",
                                        "createdOnDateInDDMmYYYFormat": null,
                                        "formattedCreatedDateForDisplay": null,
                                        "formattedUpdatedDateForDisplay": null,
                                        "privacySettingsId": 14,
                                        "profileVisibility": "EVERYONE",
                                        "showProfileVisitors": "ENABLED",
                                        "emailNotifications": "ENABLED"
                                    },
                                    "webTO": {
                                        "userDetailsId": 14,
                                        "firstName": "Stacy",
                                        "middleName": null,
                                        "lastName": "Richard",
                                        "emailId": "stacy@uvsity.com",
                                        "gender": "F",
                                        "phoneMobile": null,
                                        "phoneWork": null,
                                        "phoneHome": null,
                                        "userType": "Student",
                                        "userBaseType": "Student",
                                        "isEduInsUserDefined": true,
                                        "educationalInstitution": "Amridge University",
                                        "campus": "Tennesse",
                                        "userEducationDegreeCourse": "Master",
                                        "userEducationYear": null,
                                        "userEducationSemester": null,
                                        "userEducationCourseStatus": null,
                                        "userEducationSubject": "Medical Science",
                                        "userEducationSpecialization": "Medical Science",
                                        "professorConnectionCount": 1,
                                        "studentConnectionCount": null,
                                        "alumniConnectionCount": null,
                                        "noOfRatingStars": null,
                                        "profilePicName": "https://s3.amazonaws.com/uvsityImages/14"
                                    }
                                }
                            }
                        ]
                    })));
                    return;
                }
                // user authenticate
                if (connection.request.url.includes('/authenticate') && connection.request.method === RequestMethod.Post) {
                    connection.mockRespond(new Response(new ResponseOptions({
                        status: 200,
                        body: {}
                    })));
                    return;
                }
                // pass through any requests not handled above (updated with suggestion from Ryan's comment to include all request options)
                var realHttp = new Http(realBackend, options);
                var requestOptions = new RequestOptions({
                    method: connection.request.method,
                    headers: connection.request.headers,
                    body: connection.request.getBody(),
                    url: connection.request.url,
                    withCredentials: connection.request.withCredentials,
                    responseType: connection.request.responseType
                });
                realHttp.request(connection.request.url, requestOptions)
                    .subscribe(function (response) {
                    connection.mockRespond(response);
                }, function (error) {
                    connection.mockError(error);
                });
            }, 500);
        });
        return new Http(backend, options);
    },
    deps: [MockBackend, BaseRequestOptions, XHRBackend]
};
//# sourceMappingURL=backend.service.js.map